import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "rounded-lg border border-gray-200 bg-white" }
const _hoisted_2 = { class: "divide-y divide-gray-100" }
const _hoisted_3 = ["aria-label", "onClick"]
const _hoisted_4 = { class: "min-w-0 flex-1" }
const _hoisted_5 = { class: "block text-sm font-medium text-gray-900" }
const _hoisted_6 = { class: "block truncate text-xs text-gray-500 group-hover:text-gray-700" }
const _hoisted_7 = ["aria-label"]
const _hoisted_8 = ["aria-label", "aria-pressed", "title", "onClick"]
const _hoisted_9 = {
  class: "h-3.5 w-3.5",
  viewBox: "0 0 16 16",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.75",
  "stroke-linecap": "round",
  "aria-hidden": "true"
}
const _hoisted_10 = ["d"]

import { PencilIcon } from '@heroicons/vue/20/solid'

import ResetButton from './ResetButton.vue'


export default {
  __name: 'WordingPanel',
  props: {
  items: { type: Array, required: true },
  resettable: { type: Boolean, default: false }
},
  emits: ['edit', 'align', 'reset'],
  setup(__props, { emit: __emit }) {



const emit = __emit

const ALIGN_OPTIONS = [
  { value: 'left', label: 'Align left', lines: ['M2 4h12', 'M2 8h8', 'M2 12h10'] },
  { value: 'center', label: 'Align center', lines: ['M2 4h12', 'M4 8h8', 'M3 12h10'] },
  { value: 'right', label: 'Align right', lines: ['M2 4h12', 'M6 8h8', 'M4 12h10'] }
]

const choose = (item, value) => {
  if (item.align !== value) emit('align', item.field, value)
}

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "border-b border-gray-200 px-3.5 py-2.5" }, [
      _createElementVNode("h4", { class: "text-sm font-semibold text-gray-900" }, "Wording")
    ], -1)),
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item) => {
        return (_openBlock(), _createElementBlock("li", {
          key: item.field,
          class: "flex items-center gap-2 pr-3.5"
        }, [
          _createElementVNode("button", {
            type: "button",
            class: "group flex min-w-0 flex-1 items-center gap-3 py-3 pl-3.5 text-left",
            "aria-label": `Edit the ${item.label.toLowerCase()}`,
            onClick: $event => (emit('edit', item.field))
          }, [
            _createElementVNode("span", _hoisted_4, [
              _createElementVNode("span", _hoisted_5, _toDisplayString(item.label), 1),
              _createElementVNode("span", _hoisted_6, _toDisplayString(item.value), 1)
            ]),
            _createVNode(_unref(PencilIcon), {
              class: "h-4 w-4 shrink-0 text-gray-300 transition-colors group-hover:text-gray-600",
              "aria-hidden": "true"
            })
          ], 8, _hoisted_3),
          (item.align)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                role: "group",
                "aria-label": `Align the ${item.label.toLowerCase()}`,
                class: "flex shrink-0 overflow-hidden rounded-md ring-1 ring-gray-200"
              }, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(ALIGN_OPTIONS, (option) => {
                  return _createElementVNode("button", {
                    key: option.value,
                    type: "button",
                    class: _normalizeClass(["flex h-7 w-7 items-center justify-center transition-colors", 
              item.align === option.value
                ? 'bg-gray-900 text-white'
                : 'text-gray-400 hover:bg-gray-50 hover:text-gray-700'
            ]),
                    "aria-label": option.label,
                    "aria-pressed": item.align === option.value,
                    title: option.label,
                    onClick: $event => (choose(item, option.value))
                  }, [
                    (_openBlock(), _createElementBlock("svg", _hoisted_9, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(option.lines, (line) => {
                        return (_openBlock(), _createElementBlock("path", {
                          key: line,
                          d: line
                        }, null, 8, _hoisted_10))
                      }), 128))
                    ]))
                  ], 10, _hoisted_8)
                }), 64))
              ], 8, _hoisted_7))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ]),
    _createVNode(ResetButton, {
      disabled: !__props.resettable,
      question: "Put the wording back to the default?",
      onReset: _cache[0] || (_cache[0] = $event => (emit('reset')))
    }, null, 8, ["disabled"])
  ]))
}
}

}